import type { BadgeProps } from 'shared/ui/Badge';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { CampaignStatusModel } from './model';

export const CAMPAIGN_STATUS_BADGE_PROPS: Record<CampaignStatusModel, BadgeProps> = {
  draft: { text: 'Draft', color: 'slate' },
  inReview: { text: 'In review', color: 'mint' },
  paused: { text: 'Paused', color: 'slate' },
  running: { text: 'Running', color: 'deepGreen' },
  budgetReached: { text: 'Overbudget', color: 'magenta' },
  deactivated: { text: 'Deactivated', color: 'red' },
  noCcAdded: { text: 'No CC Added', color: 'orange' },
};

export const campaignsKey = createQueryKeys('campaigns', {
  campaign: (id: number) => [id],
  campaignsList: [''],
});
